import { render, staticRenderFns } from "./Dentistical.vue?vue&type=template&id=4040cec6&"
import script from "./Dentistical.vue?vue&type=script&lang=js&"
export * from "./Dentistical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports